/* unplugin-vue-components disabled */import { render } from "./rednoteNew.vue?vue&type=template&id=abd8888e&scoped=true"
import script from "./rednoteNew.vue?vue&type=script&lang=js"
export * from "./rednoteNew.vue?vue&type=script&lang=js"

import "./rednoteNew.vue?vue&type=style&index=0&id=abd8888e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abd8888e"]])

export default __exports__